import { render, staticRenderFns } from "./UserCoursesOngoingSidebar.vue?vue&type=template&id=bd340c62"
import script from "./UserCoursesOngoingSidebar.vue?vue&type=script&lang=js"
export * from "./UserCoursesOngoingSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports